import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  SiteMeetingReportRequest,
  SiteMeetingReportResponse,
} from "../types/SiteMeetingReport";

const baseUrl = "/api/SiteMeetingReport";

export const generateSiteMeetingReport = async (
  request: SiteMeetingReportRequest,
): Promise<SiteMeetingReportResponse> => {
  const token = await getApiAccessToken();
  const response = await apiClient.post<SiteMeetingReportResponse>(
    `${baseUrl}/generate`,
    request,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
};
